import { each, isArray, isFunction } from 'lodash-es'

export default class Subscribe {

  constructor () {
    this.events = []
  }

  on (type, fn, once = false) {
    let types = isArray(type) ? type : [type]
    each(types, item => {
      this.events.push({type: item, fn, once})
    })
    return this
  }

  off (type, fn) {
    each(this.events, (item, idx) => {
      if (item.type === type && item.fn === fn) {
        setTimeout(((i) => () => this.events.splice(i, 1))(idx), 0)
      }
    })
  }

  once (type, fn) {
    return this.on(type, fn, true)
  }

  emit () {
    let args = Array.from(arguments)
    let type = args.shift()
    each(this.events, (item, idx) => {
      if (item.type === type && isFunction(item.fn)) {
        item.fn(...args, type)
        if (item.once) setTimeout(((i) => () => this.events.splice(i, 1))(idx), 0)
      }
    })
    return this
  }

  clear () {
    this.events = []
  }
}